import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store.ts";
import type { TimeSlotFilters, TimeSlotSlice } from "./timeSlotsTypes.ts";

const initialState: TimeSlotSlice = {
  page: 1,
  rowsPerPage: 25,
  filter: {},
  sort: {
    key: "name",
    order: "asc",
  },
};

export const timeSlotsSlice = createSlice({
  name: "timeSlots",
  initialState,
  reducers: {
    setPage: (state, action: PayloadAction<TimeSlotSlice["page"]>) => {
      state.page = action.payload;
    },
    setRowsPerPage: (
      state,
      action: PayloadAction<TimeSlotSlice["rowsPerPage"]>,
    ) => {
      state.rowsPerPage = action.payload;
    },
    setFilter: (
      state,
      action: PayloadAction<
        [filterType: keyof TimeSlotFilters, filterValue: string | undefined]
      >,
    ) => {
      const [filterType, filterValue] = action.payload;
      state.filter[filterType] = filterValue;
    },
    setSort: (state, action: PayloadAction<TimeSlotSlice["sort"]>) => {
      state.sort = action.payload;
    },
  },
});

export const { setPage, setRowsPerPage, setFilter, setSort } =
  timeSlotsSlice.actions;

export const selectPage = (state: RootState) => state.timeSlots.page;
export const selectRowsPerPage = (state: RootState) =>
  state.timeSlots.rowsPerPage;
export const selectFilter = (state: RootState) => state.timeSlots.filter;
export const selectSort = (state: RootState) => state.timeSlots.sort;

export default timeSlotsSlice.reducer;
